<template>
  <b-modal :open="open" @close="onClose" :title="$t('text.change_password')">
    <template v-slot:default>
      <form>
        <b-input
                :label="$t('fields.old_password')"
                v-model="old_password"
                type="password"
                :errorMessage="errorMessage.old_password"
        />
        <b-input
                :label="$t('fields.new_password')"
                v-model="password"
                :errorMessage="errorMessage.password"
                type="password"
        />
        <b-input
                :label="$t('fields.confirm_password')"
                v-model="retype_password"
                :errorMessage="errorMessage.retype_password"
                type="password"
        />
      </form>
    </template>
    <template v-slot:modal-footer>
      <button @click="onSave" class="primary-btn">
        {{ $t("text.save") }}
      </button>
    </template>
  </b-modal>
</template>
<script lang="ts">
import {computed, ref} from "vue";
import BInput from "../../components/Form/BInput.vue";
import BModal from "../../components/Modal/BModal.vue";
import BSelect from "../../components/Form/BSelect.vue";
import userApis from "../../api/user";
import { useToast } from "vue-toastification";
import { useI18n } from "vue-i18n";
import { useStore } from "vuex";
import _ from "lodash";

  export default {
    components: { BSelect, BModal, BInput },
    setup() {
      const store = useStore();
      const toast = useToast();
      const {t} = useI18n({useScope: "global"});
      const open = ref(false);
      const password = ref("");
      const old_password = ref("");
      const retype_password = ref("");
      const errorMessage = ref({});
      const userId = ref(null);
      // const userComputed = computed(() => store.state.userInfo);
      // const user = ref({...userComputed.value});

      function validatePassword(password) {
        const re = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;

        return re.test(String(password));
      }

      const validate = function () {
        let isValid = true;

        if(!old_password.value || !old_password.value.toString().trim()){
          isValid = false;
          errorMessage.value.old_password = t("errors.required");
        }
        else {
          errorMessage.value.old_password = "";
        }
        if (!password.value.length || !validatePassword(password.value)) {
          isValid = false;
          errorMessage.value.password = t("errors.password_validate");
        }
        else {
          errorMessage.value.password = "";
        }
        if(!retype_password.value || !retype_password.value.toString().trim()){
          isValid = false;
          errorMessage.value.retype_password = t("errors.required");
        }
        else {
          if (password.value !== retype_password.value) {
            isValid = false;
            errorMessage.value.retype_password = t("text.error_confirm_password");
          }
          else {
            errorMessage.value.retype_password = "";
          }
        }
        return isValid;
      }
      const onSave = async function(){
        if (!validate()) {
          return;
        }
        open.value = false;
        try{
          const { data } = await userApis.updateUserPassword(userId.value, {
            old_password: old_password.value,
            password: password.value,
            retype_password: retype_password.value,
          });
          toast.success(t("text.edit_successful"));
        } catch (error) {
          errorMessage.value.old_password = t("errors.error_old_password");
          // const messages = error.response.data.errors;
          // errorMessage.value = _.mapValues(messages, (value) => {
          //   return value[0];
          // });
        }
      };
      const onClose = function () {
        open.value = false;
      };
      const onOpen = async function(id){
        open.value = true;
        userId.value =id;
        errorMessage.value = {};
      };

      return{
        errorMessage,
        old_password,
        password,
        retype_password,
        open,
        onClose,
        onOpen,
        onSave,
      }
    }
  }
</script>